import { useState, useEffect, useMemo } from 'react';
import config from '../../config/config';
import uploadFile from '../../utilities/uploadFile';
import { useParams } from 'react-router-dom';
import MultiAutocomplete from './MultiAutocomplete';
import LoadingSpinner from './LoadingSpinner';
import { renderArrayStr } from '../../utilities/shared';
import {
  addMeetingAttendee,
  removeMeetingAttendee,
  getNotAttendedContacts
} from '../../utilities/meetings';

import styles from '../styles/EditMeetingForm.module.css';

import axios from 'axios';

function EditAttendeesForm() {
  //new attendees to be added
  const [contactsList, setContactsList] = useState([]);
  const contactNames = useMemo(() => {
    return contactsList.map((c) => c.label);
  }, [contactsList]);

  //curr attendees to be removed
  const [attendeesList, setAttendeesList] = useState([]);
  const attendeeNames = useMemo(() => {
    return attendeesList.map((a) => a.label);
  }, [attendeesList]);

  const [meeting_notes, setNotes] = useState('No notes included');

  // for file upload
  const [isLoaded, setIsLoaded] = useState(true);
  const [uploadFiles, setUploadFiles] = useState(null);

  //For Drop downs
  const [not_attended, setNotAttended] = useState([]);
  const [attended, setAttended] = useState([]);

  const { meeting_name } = useParams();
  const { date_time } = useParams();
  const { meeting_id } = useParams();

  async function getAllContacts() {
    const res = await getNotAttendedContacts({ meeting_id });
    if (res?.status === 200) {
      const notAttendedData = res.data.map(({ contact_name, contact_id }) => ({
        label: contact_name,
        value: contact_id
      }));
      setNotAttended(notAttendedData);
    }
  }

  async function getAttendeeEmails() {
    await axios
      .get(
        config.apiURL + `/contacts_attended_meeting/meeting_id/${meeting_id}`,
        {
          headers: {
            'Content-Type': 'application/json',
            token: config.getToken()
          }
        }
      )
      .then(({ data }) => {
        const attendedData = data.map(({ contact_name, contact_id }) => ({
          label: contact_name,
          value: contact_id
        }));
        setAttended(attendedData);
      });
  }

  async function getMeetingNotes() {
    await axios
      .get(config.apiURL + `/meeting_notes?meeting_id=${meeting_id}`, {
        headers: {
          'Content-Type': 'application/json',
          token: config.getToken()
        }
      })
      .then((response) => {
        return setNotes(response.data.notes);
      });
  }

  async function addMeetingNotes(newData) {
    await axios
      .put(config.apiURL + `/add_meeting_notes`, newData, {
        headers: {
          'Content-Type': 'application/json',
          token: config.getToken()
        }
      })
      .then((res) => {
        alert(`Notes have been added!`);
        window.location.reload();
      });
  }

  async function addMeetingFiles(e) {
    e.preventDefault();
    setIsLoaded(false);
    for (let i = 0, numFiles = uploadFiles.length; i < numFiles; i++) {
      const file = uploadFiles[i];
      const s3Key = `/outreach/meetings/${meeting_id}/${file.name}`;
      let r = await uploadFile(s3Key, file);
      console.log(r);
    }
    setIsLoaded(true);
    alert('Meeting record successfully added!');
    window.location.reload();
  }

  useEffect(() => {
    if (isLoaded) {
      //if the result is not ready so you make the axios call
      getAllContacts();
      getAttendeeEmails();
      getMeetingNotes();
    }
  }, [isLoaded]); // eslint-disable-line react-hooks/exhaustive-deps

  async function addAttendeeHandler(event) {
    event.preventDefault();
    if (contactsList.length < 1) {
      alert('Must select names before submittal');
      return;
    }
    const responseList = await Promise.all(
      contactsList.map((contact) => addMeetingAttendee({ meeting_id, contact }))
    );
    const msg = responseList
      .map(({ res, contact }) => {
        if (res?.status === 200) {
          return `${contact.label} has been added to meeting`;
        } else {
          return undefined;
        }
      })
      .filter((r) => r !== undefined);
    alert(msg.join(', \n'));
    window.location.reload();
  }

  async function removeAttendeeHandler(event) {
    event.preventDefault();
    if (attendeesList.length < 1) {
      alert('Must select names before submittal');
      return;
    }
    const responseList = await Promise.all(
      attendeesList.map((attendee) =>
        removeMeetingAttendee({ meeting_id, attendee })
      )
    );
    const msg = responseList
      .map(({ res, attendee }) => {
        if (res?.status === 200) {
          return `${attendee.label} has been removed from meeting`;
        } else {
          return undefined;
        }
      })
      .filter((r) => r !== undefined);
    alert(msg.join(', \n'));
    window.location.reload();
  }
  function addMeetingNotesHandler(event) {
    event.preventDefault();
    if (meeting_notes === '') {
      alert('Must enter notes before submittal');
    }
    if (meeting_notes === null) {
      alert('Must enter notes before submittal');
    } else {
      alert(`Your notes have been added`);
    }

    // Get form data
    const postData = {
      notes: meeting_notes,
      // meeting_id: {
      //   String: meeting_id,
      //   Valid: true,
      // },
      meeting_id: meeting_id
    };

    // Post request
    addMeetingNotes(postData);
  }

  const myChangeHandler = (event) => {
    let nam = event.target.name;
    let val = event.target.value;

    if (nam === 'files') {
      setUploadFiles(event.target.files);
    } else if (nam === 'meetingNotes') {
      if (val.includes('/')) {
        alert("Cannot use the character '/' for the meeting notes.");
        document.getElementById('meetingNotes').value = '';
      } else {
        setNotes(val);
      }
    }
  };
  const updateReference = {
    contactsList: [contactsList, setContactsList],
    attendeesList: [attendeesList, setAttendeesList],
    reset: {
      contacts: () => setContactsList([]),
      attendees: () => setAttendeesList([])
    }
  };
  function handleReset(e) {
    const { name, value } = e.target;
    updateReference[name][value]();
  }

  function onAutocompleteChange(key, option) {
    if (updateReference[key][0].map((obj) => obj.value).includes(option.value))
      return;

    updateReference[key][1]((prev) => [...prev, option]);
  }

  if (isLoaded) {
    return (
      <div className={styles.container}>
        <h3 id='meeting_name' style={{ width: '400px', marginLeft: '35px' }}>
          {meeting_name} <br /> {date_time.substring(0, 10)}
        </h3>
        <div className={styles.formBox}>
          <h3 id='meeting_name' style={{ width: '400px', marginLeft: '35px' }}>
            Edit Meeting Attendees Information
          </h3>
          <div className={`${styles.columnContainer}`}>
            <div className={styles.rowContainerStart}>
              <div className={styles.namesList}>
                {renderArrayStr(contactNames)}
                <button
                  onClick={handleReset}
                  name='reset'
                  value='contacts'
                  className={`${styles.bttn} ${styles.resetNames}`}
                >
                  x
                </button>
              </div>
              <MultiAutocomplete
                className={styles.col}
                placeholder='search...'
                inputLabel='Select attendees to add'
                optionsData={not_attended}
                onValueChange={(val) =>
                  onAutocompleteChange('contactsList', val)
                }
              />
            </div>
            <div className={styles.reverseRowContainer}>
              <form
                id='addAttendeeForm'
                onSubmit={addAttendeeHandler}
                style={{ marginBottom: '0px' }}
              >
                <button
                  className={styles.bttn}
                  type='submit'
                  id='addMeetingAttendeeBtn'
                >
                  Add
                </button>
              </form>
            </div>
            <div className={styles.rowContainerStart}>
              <div className={styles.namesList}>
                {renderArrayStr(attendeeNames)}
                <button
                  onClick={handleReset}
                  name='reset'
                  value='attendees'
                  className={`${styles.bttn} ${styles.resetNames}`}
                >
                  x
                </button>
              </div>
              <MultiAutocomplete
                className={styles.col}
                placeholder='search...'
                inputLabel='Select attendees to remove'
                optionsData={attended}
                onValueChange={(val) =>
                  onAutocompleteChange('attendeesList', val)
                }
              />
            </div>
            <div className={styles.reverseRowContainer}>
              <form
                id='removeAttendeeForm'
                onSubmit={removeAttendeeHandler}
                style={{ marginBottom: '0px' }}
              >
                <button
                  className={styles.bttn}
                  type='submit'
                  id='removeMeetingAttendeeBtn'
                >
                  Remove
                </button>
              </form>
            </div>
            <form id='meetingNotesForm' onSubmit={addMeetingNotesHandler}>
              <label>Notes</label>
              <div className={styles.rowContainerStart}>
                <textarea
                  id='meetingNotes'
                  name='meetingNotes'
                  onChange={myChangeHandler}
                  value={meeting_notes}
                  style={{
                    width: '100%',
                    height: '100%'
                  }}
                />
              </div>
              <div className={styles.reverseRowContainer}>
                <button
                  className={styles.bttn}
                  type='submit'
                  id='addMeetingNotesBtn'
                >
                  Add Notes
                </button>
              </div>
            </form>
            <form id='addMeetingFiles' onSubmit={addMeetingFiles}>
              <label>Upload files</label>

              <i>* hold CRTL/CMD to select multiple files</i>
              <input
                type='file'
                id='files'
                name='files'
                multiple
                onChange={myChangeHandler}
                style={{
                  backgroundColor: 'white',
                  width: '100%',
                  resize: 'vertical'
                }}
              />
              <div className={styles.reverseRowContainer}>
                <button
                  className={styles.bttn}
                  type='submit'
                  id='addMeetingDocBtn'
                >
                  Upload
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  } else if (!isLoaded) {
    return (
      <>
        <div>
          <h3 className='all-center'>Uploading files. Please wait...</h3>
          <LoadingSpinner />
        </div>
      </>
    );
  }
}

export default EditAttendeesForm;
